// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"d147f173","237":"699dc44a","298":"d5a42f1c","380":"39e01403","453":"796b7e4a","685":"3fd8ac71","727":"48bb21c9","766":"b8a0f2e9","823":"25d15cb5","913":"f70c5d2a","982":"eff226c5"}[chunkId] + ".chunk.js";
};